"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var colors = _interopRequireWildcard(require("../colors"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _IconStack = _interopRequireDefault(require("../IconStack"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
} // Temporary fix to resize the icon stack to the correct size.


var scaleStyle = {
  transform: 'scale(0.65)'
};
var ascDirection = 'asc';
var descDirection = 'desc';

var TableHeader = function TableHeader(_ref) {
  var children = _ref.children,
      className = _ref.className,
      sortable = _ref.sortable,
      sorted = _ref.sorted,
      toggleSort = _ref.toggleSort,
      rest = _objectWithoutProperties(_ref, ["children", "className", "sortable", "sorted", "toggleSort"]);

  var direction = sorted && (sorted.desc ? 'desc' : 'asc');

  var sortIcons = _react["default"].createElement(_IconStack["default"], {
    style: scaleStyle
  }, _react["default"].createElement(_Icon["default"], {
    color: direction === ascDirection ? colors.shale : colors.alloy,
    name: "sort-up-f"
  }), _react["default"].createElement(_Icon["default"], {
    color: direction === descDirection ? colors.shale : colors.alloy,
    name: "sort-down-f"
  }));

  return _react["default"].createElement("div", _extends({
    className: (0, _classnames["default"])('rt-th', className),
    role: "columnheader",
    tabIndex: "-1"
  }, rest, {
    onClick: function onClick(e) {
      return toggleSort && toggleSort(e);
    }
  }), children, sortable ? sortIcons : null);
};

TableHeader.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  sortable: _propTypes["default"].bool,
  toggleSort: _propTypes["default"].func,
  sorted: _propTypes["default"].shape({
    desc: _propTypes["default"].any
  })
};
var _default = TableHeader;
exports["default"] = _default;